import styles from 'styles/Dashboard/Editor';

export const borderColor = styles.tint4;
export const borderWidth = '1px';
